import { useContext } from "react";
import { useParams } from "react-router-dom";
import { Stack } from "@mui/material";
import Editor from "@monaco-editor/react";
import { EditorContext } from "../../Editor";
import { useUpdateTemplateStyleMutation } from "@/api/templatesApi";
import { useUpdateWebsiteStylesMutation } from "@/features/organizations/api/websiteApi";
import LoadingButton from "@mui/lab/LoadingButton";

const StylesEditor = () => {
  const { templateId, websiteId, organizationId } = useParams();
  const { template, website, styles, setStyles, isLoading, setIsLoading } = useContext(EditorContext);
  const [updateTemplateStyle, templateMutation] = useUpdateTemplateStyleMutation();
  const [updateWebsiteStyles, websiteMutation] = useUpdateWebsiteStylesMutation();

  const handleSave = async () => {
    if (!organizationId || (!websiteId && !templateId)) return;
    setIsLoading(true);

    if (templateId) {
      await updateTemplateStyle({
        styles,
        templateId,
      });
    } else {
      await updateWebsiteStyles({
        organizationId,
        websiteId,
        website: {
          styles,
        },
      });
    }

    setIsLoading(false);
  };

  return (
    <Stack spacing={2}>
      <LoadingButton variant="contained" color="success" size="small" onClick={handleSave} loading={isLoading || templateMutation.isLoading || websiteMutation.isLoading}>
        Guardar
      </LoadingButton>
      <Editor
        height="90vh"
        theme="vs-dark"
        defaultLanguage="css"
        defaultValue={templateId ? template?.styles : website?.styles}
        value={styles}
        onChange={(value) => setStyles(value ?? "")}
      />
    </Stack>
  );
};

export default StylesEditor;
